export const loginConstants = {

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
       LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
       LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
   
   
}